import { Link, LinkProps } from 'react-router-dom';

export type ExternalLinkProps = LinkProps & React.RefAttributes<HTMLAnchorElement>;

export const ExternalLink = (props: ExternalLinkProps) => (
  <Link target="_blank" rel="noopener noreferrer" {...props} />
);
